import React from "react";
import ForgotPasswordModal from "../Components/ForgotPasswordModal";
import LockIcon from "../Assets/Icons/lockIcon.svg"
import Logo from "../Assets/logo.png";

export default function ForgetPasswordPage() {
  return (
    <div>
      <div className="flex items-center justify-center flex-col gap-6 h-[100vh]">
        <img className="w-[7.5rem] h-[2.25rem]" src={Logo} />
        <ForgotPasswordModal
          img={LockIcon}
          heading="Forgot Password"
          text="To reset your password, please enter your email address. You may need to check your spam folder"
          btntext="Send"
        />
      </div>
    </div>
  );
}
